import { createAction, props } from '@ngrx/store';

import { User } from '../../models';

export const getUser = createAction('GET_USER');
export const getUserSuccess = createAction('GET_USER_SUCCESS', props<{ user: User }>());
export const getUserFailure = createAction('GET_USER_FAILURE', props<{ error: string }>());
